import { passwordHints } from "../../Containers/Constants/commenFeatures";

/**
 * This regex checks for integers.
 *
 * - Tests true for literals like - `"", "2", "32434325435"`
 * - Tests false for literals like - `"a", "12as", "as23", "123.13"`
 */
export const integerExp = /^\d*$/;

/**
 * This regex checks for alphabets.
 *
 * - Tests true for literals like - `"", "a", "vfsgreftgr"`
 * - Tests false for literals like - `"1", "12as", "as23", "s$ajkd"`
 */
export const alphabetExp = /^[a-zA-Z ]*$/;

/**
 * This regex checks for alphanumeric characters.
 *
 * - Tests true for literals like - `"", "asd", "ASD", "123"`
 * - Tests false for literals like - `"_", "-", "$", ".", " ", [any other non-alphanumeric character]`
 */
export const alphaNumExp = /^[a-zA-Z0-9]*$/;

/**
 * This regex checks for alphanumeric and _characters.
 *
 * - Tests true for literals like - `"", "asd", "ASD", "123", "A123_v"`
 * - Tests false for literals like - `"-", "$", ".", " ", [any other non-alphanumeric character and _]`
 */
export const UserIdExp = /^[a-zA-Z0-9_]*$/;

/**
 * This regex checks for emails.
 *
 * - Tests true for literals like - `"", "asd", "ASD", "123"`
 * - Tests false for literals like - `"_", "-", "$", ".", " ", [any other non-alphanumeric character]`
 */
export const emailRegex =
  /^[-_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/;

/**
 * This regex checks if given string's length is between min and max characters.
 *
 * @param min min number of characters
 * @param max (optional) max number of characters. If not present then considered as infinity
 * @returns RegExp for checking if given string's length is between min and max characters
 */
export function betweenNChars(min: number, max?: number) {
  return new RegExp("^.{" + min + "," + (max || "") + "}");
}

/**
 * This regex checks if the string is a valid pan
 */
export const pan = /^[a-zA-Z]{5}[\d]{4}[a-zA-Z]{1}$/;

/**
 * This regex checks if the string is a valid phone/mobile number
 */
export const phoneNo = /^[6789]\d{9}$/;

// This regex checks if the string is a valid Ip address

export const ValidateIPaddress =
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

/**
 * This regex checks if the string is a strong password
 */

export const notAllowedSplExp = /^[^()<>?%+:;{}[\]\\|~`^\-‘",./₹]*$/;
const lowerUpperCase = new RegExp("(?=.*[a-z])(?=.*[A-Z])");
const anumNSplCase = new RegExp("(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$&])");
const noSpaceCase = /^\S*$/;

export function checkPasswordStranth(
  min: number,
  max: number,
  val: string,
  email?: string
) {
  const list = JSON.parse(JSON.stringify(passwordHints));
  const checkLength = betweenNChars(min, max);

  checkLength.test(val)
    ? (list.checkLength = "")
    : (list.checkLength = passwordHints.checkLength);

  email !== val
    ? (list.sameAsLoginId = "")
    : (list.sameAsLoginId = passwordHints.sameAsLoginId);

  noSpaceCase.test(val)
    ? (list.NoSpace = "")
    : (list.NoSpace = passwordHints.NoSpace);

  lowerUpperCase.test(val)
    ? (list.upLowCase = "")
    : (list.upLowCase = passwordHints.upLowCase);

  anumNSplCase.test(val)
    ? (list.alpNumSpcl = "")
    : (list.alpNumSpcl = passwordHints.alpNumSpcl);

  notAllowedSplExp.test(val)
    ? (list.splNotAllow = "")
    : (list.splNotAllow = passwordHints.splNotAllow);

  return list;
}
